import React from 'react';
import LongText from '../Elements/LongText';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import JsxHelper from '../Helpers/JsxHelper';
import urlHelper from '../Helpers/urlHelper';
import { getAssignmentStatusName } from '../Enums/AssignmentStatusEnum';

export default class SurveyTransferMappingItem {
  constructor(item) {
    if (item === undefined) {
      this.SurveyTransferMappingId = '';
      this.SourceSystemTpInstanceId = '';
      this.SourceTpSurveyId = '';
      this.SourceThirdPartySurveyId = '';
      this.TargetSystemTpInstanceId = '';
      this.TargetTpSurveyId = '';
      this.TargetThirdPartySurveyId = '';
      this.TargetStatus = '';
      this.SendTriggers = false;
      this.ApprovedOnUtc = '';
      this.ApprovedBy = '';
      this.IsActive = '';
      this.Comment = '';
      this.ClientName = '';
      this.SourceTpSurveyName = '';
      this.TargetTpSurveyName = '';
    } else {
      this.initialize(item);
    }
  }

  initialize(item) {
    this.SurveyTransferMappingId = item.surveyTransferMappingId;
    this.SourceSystemTpInstanceId = item.sourceSystemTpInstanceId;
    this.SourceTpSurveyId = item.sourceTpSurveyId;
    this.SourceThirdPartySurveyId = item.sourceThirdPartySurveyId;
    this.TargetSystemTpInstanceId = item.targetSystemTpInstanceId;
    this.TargetTpSurveyId = item.targetTpSurveyId;
    this.TargetThirdPartySurveyId = item.targetThirdPartySurveyId;
    this.TargetStatus = item.targetStatus;
    this.SendTriggers = item.sendTriggers === true;
    this.ApprovedOnUtc = item.approvedOnUtc;
    this.ApprovedBy = item.approvedBy;
    this.IsActive = item.isActive;
    this.Comment = item.comment;
    this.ClientName = item.clientName;
    this.SourceTpSurveyName = item.sourceTpSurveyName;
    this.TargetTpSurveyName = item.targetTpSurveyName;
  }

  static NameOfTheIdField() {
    return 'SurveyTransferMappingId';
  }

  static nameOfTheItemDetailList() {
    return 'Survey Transfer Mapping';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['ApprovedOnUtc'];

  static DateOnlyFields = [];

  static BoolFields = ['IsActive', 'SendTriggers'];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { name: 'SurveyTransferMappingId', label: 'Mapping Id', width: TabListTableCellWidthEnum.Full },
        { name: 'ClientName', label: 'Client' },
        { name: 'SourceSystemTpInstanceId', label: 'Source System (TpInstance Id)' },
        { name: 'SourceTpSurveyName', label: 'Source Survey' },
        { name: 'SourceThirdPartySurveyId', label: 'Source 3rd Party Survey Id' },
        { name: 'TargetSystemTpInstanceId', label: 'Target System (TpInstance Id)' },
        { name: 'TargetTpSurveyName', label: 'Target Survey' },
        { name: 'TargetThirdPartySurveyId', label: 'Target 3rd Party Survey Id' },
        { name: 'IsActive', label: 'Is Active' },
        { name: 'SendTriggers', label: 'Send Trigger Emails' },
        { name: 'ApprovedOnUtc', label: 'Approved On (UTC)' },
        { name: 'ApprovedBy', label: 'Approved By' },
        { name: 'Comment', label: 'Comment', width: TabListTableCellWidthEnum.Full },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or a function
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Client',
        orderById: 'ClientName',
        data: 'ClientName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Source Survey',
        orderById: 'SourceTpSurveyName',
        data: 'SourceTpSurveyName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Source 3rd Party Survey Id',
        orderById: 'SourceThirdPartySurveyId',
        data: 'SourceThirdPartySurveyId',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Target Survey',
        orderById: 'TargetTpSurveyName',
        data: 'TargetTpSurveyName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Target 3rd Party Survey Id',
        orderById: 'TargetThirdPartySurveyId',
        data: 'TargetThirdPartySurveyId',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Target Status',
        // Non-sortable: the backend ordering switch doesn't map TargetStatus.
        orderById: '',
        // The DB stores an int; show its AssignmentStatusEnum name.
        data: (item) => getAssignmentStatusName(item.TargetStatus),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Is Active',
        orderById: 'IsActive',
        data: (item) => JsxHelper.YesNo(item.IsActive),
        className: 'text-center',
      },
      {
        label: 'Send Trigger Emails',
        // Non-sortable: the backend ordering switch doesn't map SendTriggers.
        orderById: '',
        data: (item) => JsxHelper.YesNo(item.SendTriggers),
        className: 'text-center',
      },
      {
        label: 'Approved On (UTC)',
        orderById: 'ApprovedOnUtc',
        data: (item) => (item.ApprovedOnUtc ? dateTimeHelper.toYYYYsMMsDD(item.ApprovedOnUtc) : '-'),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Id',
        orderById: 'SurveyTransferMappingId',
        minWidth: 50,
        data: (item) => (
          <LongText
            text={item.SurveyTransferMappingId}
            maxLength={0}
          />
        ),
      },
      {
        label: 'Actions',
        orderById: '',
        type: FieldTypesEnum.ActionButton,
        data: SurveyTransferMappingItem.getActionsContent,
        minWidth: 50,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            tooltipText: 'Edit this mapping',
            onClick: () => SurveyTransferMappingItem.editFunction(item),
          },
          {
            iconName: 'fa-solid fa-arrow-up-right-from-square',
            text: 'View question mapping',
            tooltipText: 'View question mapping',
            // Open in a new tab via window.open rather than the menu's `url` prop:
            // DataTableActionButton gates `url` through urlHelper.isUrlOnWhiteList and falls back
            // to '/' (Home) for non-whitelisted hosts (e.g. localhost).
            onClick: () =>
              window.open(
                urlHelper.getProperUrl('surveytransferquestionrulesdetails', `id=${item.SurveyTransferMappingId}`),
                '_blank'
              ),
          },
          {
            iconName: 'fa-solid fa-rotate',
            text: 'Reset',
            tooltipText: "Re-import and regenerate this mapping's rules",
            // Only allowed while the mapping is not yet approved.
            disabled: !!item.ApprovedOnUtc,
            onClick: () => SurveyTransferMappingItem.resetFunction(item),
          },
          {
            iconName: 'fa-solid fa-arrows-rotate',
            text: 'Refresh',
            // Non-destructive: reloads the source/target survey questions & answer options
            // (update existing, insert new) without touching the mapping rules, so it stays
            // enabled even after approval.
            tooltipText: 'Reload the source & target survey questions and answer options (keeps the mapping rules)',
            onClick: () => SurveyTransferMappingItem.refreshFunction(item),
          },
          {
            iconName: 'fa-solid fa-check',
            text: 'Approve',
            tooltipText: 'Approve this mapping',
            // Only allowed while the mapping is not yet approved.
            disabled: !!item.ApprovedOnUtc,
            onClick: () => SurveyTransferMappingItem.approveFunction(item),
          },
          {
            iconName: item.IsActive ? 'fa-solid fa-toggle-off' : 'fa-solid fa-toggle-on',
            text: item.IsActive ? 'Deactivate' : 'Activate',
            // A mapping can only be activated once it has been approved (deactivating is always allowed).
            disabled: !item.IsActive && !item.ApprovedOnUtc,
            tooltipText: item.IsActive
              ? 'Deactivate this mapping'
              : item.ApprovedOnUtc
              ? 'Activate this mapping'
              : 'Approve the mapping before activating it',
            onClick: () => SurveyTransferMappingItem.switchActiveStateFunction(item),
          },
        ]}
      />
    );
  }

  // Wired by the hosting page (SurveyTransferMappingAdmin) to open the edit panel.
  static editFunction = (item) => {
    alert('Edit function is not wired up.');
  };

  // Wired by the hosting page (SurveyTransferMappingAdmin) to warn about, then run, the data reset.
  static resetFunction = (item) => {
    alert('Reset function is not wired up.');
  };

  // Wired by the hosting page (SurveyTransferMappingAdmin) to confirm, then run, the data refresh.
  static refreshFunction = (item) => {
    alert('Refresh function is not wired up.');
  };

  // Wired by the hosting page (SurveyTransferMappingAdmin) to confirm, then run, the approval.
  static approveFunction = (item) => {
    alert('Approve function is not wired up.');
  };

  // Wired by the hosting page (SurveyTransferMappingAdmin) to toggle the IsActive state.
  static switchActiveStateFunction = (item) => {
    alert('Switch active state function is not wired up.');
  };
}
